import { useEffect } from "react";
import { ServiceDefinitionResourcesSection } from "./ServiceDefinitionResourcesSection";
import { ghostBtnClass } from "./serviceShared";
import type { useServiceDefinitionsPanel } from "./useServiceDefinitionsPanel";

export function ServiceSetupSharedFleetView(props: {
  definitions: ReturnType<typeof useServiceDefinitionsPanel>;
  onBack: () => void;
}) {
  const { definitions, onBack } = props;

  useEffect(() => {
    definitions.openGeneralScope();
  }, [definitions]);

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center gap-2">
        <button type="button" className={ghostBtnClass} onClick={onBack}>
          ← All services
        </button>
        <h3 className="text-base font-semibold text-gray-900 dark:text-zinc-100">Shared fleet</h3>
      </div>
      <p className="text-sm text-gray-600 dark:text-zinc-400">
        Org-wide rigs and technicians available before or between service-specific assignments.
      </p>
      <ServiceDefinitionResourcesSection
        m={definitions}
        title="Shared fleet"
        description="Pool resources shared across services. New entries here are not auto-linked to a specific offering."
      />
    </div>
  );
}
